"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const GetPropositionResponse_1 = tslib_1.__importDefault(require("./GetPropositionResponse"));
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const PropositionDuration_1 = tslib_1.__importDefault(require("../enums/PropositionDuration"));
class GetPropositionListResponseItem extends GetPropositionResponse_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: '3f980181-b03a-4ee8-a784-f83e2b31e5fc',
        description: 'ID of proposition in UUID format.',
    }),
    tslib_1.__metadata("design:type", String)
], GetPropositionListResponseItem.prototype, "propositionId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(PropositionDuration_1.default)),
    (0, base_models_1.Docs)({
        example: '1_year',
        description: 'The duration of the proposition. \'obt\' is SAP code 99 and \'flex\' is SAP code 98.',
    }),
    tslib_1.__metadata("design:type", String)
], GetPropositionListResponseItem.prototype, "duration", void 0);
exports.default = GetPropositionListResponseItem;
